export default __webpack_public_path__ + "static/media/bg27.5b80c81c.jpg";